<template>
    <a :href="href" class="link-button" target="_blank">
        <span>{{ text }}</span>
        <svg style="width: 1em; margin-left: .3125em" aria-hidden="true" focusable="false" data-prefix="fas"
            data-icon="external-link-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            data-fa-i2svg="">
            <path fill="currentColor"
                d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z">
            </path>
        </svg>
    </a>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: false,
            default: "研究室のHP"
        }
    }
}
</script>

<style scoped>
a:hover {
    opacity: .5;
}

.link-button {
    text-decoration: none;
    background-color: #E76F00;
    border: solid #E76F00 1px;
    color: #FFF;
    cursor: pointer;
    justify-content: center;
    padding: 8px 12px;
    text-align: center;
    white-space: nowrap;
    border-radius: 4px;
    justify-content: space-between;
    height: auto;
    white-space: normal;
}

.link-button:hover {
    border-color: #E76F00;
    color: #FFF;
}
</style>